module.exports = __webpack_public_path__ + "static/media/area-icon.bf9a3fb9.svg";